import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { showModal, MODAL_CLIENT_OPEN_TRANSACTION } from 'redux/modules/modals'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Draggable from 'react-draggable'
import CircularProgress from '@material-ui/core/CircularProgress'
import { calculsTransaction } from 'utils/PriceCalculHelpers'
import AmericanTableIcon from 'components/AmericanTableIcon'
import FrenchTableIcon from 'components/FrenchTableIcon'
import PoolTableIcon from 'components/PoolTableIcon'
import SnookerTableIcon from 'components/SnookerTableIcon'
import ChineseTableIcon from 'components/ChineseTableIcon'
import * as Colors from '@material-ui/core/colors'
const runningColor = Colors.lightGreen['700']
const pauseColor = Colors.orange['400']
const normalColor = Colors.blueGrey['500']
const propTypes = {
  classes: PropTypes.object.isRequired,
  table: PropTypes.object.isRequired,
  addSideTable: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  showModal: PropTypes.func.isRequired
}
function getTableIcon(type) {
  let icon
  const style = {
    position: 'absolute',
    top: '2px',
    left: '2px',
    color: 'white'
  }
  switch (type) {
    case 'american':
      icon = <AmericanTableIcon viewBox="5 0 24 24" style={style} />
      break
    case 'pool':
      icon = <PoolTableIcon style={style} />
      break
    case 'snooker':
      icon = <SnookerTableIcon style={style} />
      break
    case 'carom':
      icon = <FrenchTableIcon style={style} />
      break
    case 'chinese':
      icon = <ChineseTableIcon style={style} />
      break
    default:
      icon = null
  }
  return icon
}
const styles = theme => ({
  hoverContainerStyleRow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    flexDirection: 'row'
  },
  hoverContainerStyleColumn: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    flexDirection: 'column'
  },
  normalStyle: {
    position: 'absolute',
    margin: 20,
    textAlign: 'center',
    verticalAlign: 'center',
    display: 'inline-block',
    backgroundColor: normalColor
  },
  pauseStyle: {
    position: 'absolute',
    margin: 20,
    textAlign: 'center',
    verticalAlign: 'center',
    display: 'inline-block',
    backgroundColor: pauseColor
  },
  runningStyle: {
    position: 'absolute',
    margin: 20,
    textAlign: 'center',
    verticalAlign: 'center',
    display: 'inline-block',
    backgroundColor: runningColor
  },
  totalSpan: {
    color: 'white',
    position: 'absolute',
    bottom: 5,
    right: 5,
    fontSize: 11
  },
  buttonProgress: {
    position: 'absolute',
    color: 'white',
    top: '50%',
    left: '50%',
    marginTop: -16,
    marginLeft: -16
  },
  tableButton: {
    minWidth: '0',
    minHeight: '0',
    width: '100%',
    height: '100%',
    color: 'white',
    margin: 0,
    fontSize: 20
  }
})
class PlanSingleComponent extends Component {
  state = { hover: false, total: 0 }
  timer = null
  updateState = props => {
    if (!props.table) return
    if (props.table.currentTransaction) {
      const totals = calculsTransaction(props.table.currentTransaction)
      this.setState({ total: totals.total.toFixed(2) })
    }
  }

  handleCreateTransactionForPool = e => {
    if (this.props.table.currentTransaction) return
    this.props.showModal(MODAL_CLIENT_OPEN_TRANSACTION, this.props.table)
  }
  handleClick = e => {
    if (this.props.table.currentTransaction) {
      if (this.props.table.currentTransaction.isSided) {
        this.props.history.push('/table/' + this.props.table.key)
      } else {
        this.props.addSideTable(this.props.table)
      }
    } else {
      this.props.showModal(MODAL_CLIENT_OPEN_TRANSACTION, this.props.table)
    }
  }
  componentWillMount() {
    const { table } = this.props
    if (table.currentTransaction) {
      if (!table.currentTransaction.pool.isPaused) {
        this.launchTimer()
      } else {
        this.updateState(this.props)
      }
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.table && nextProps.table.currentTransaction) {
      clearInterval(this.timer)
      if (nextProps.table.currentTransaction.pool.isPaused) {
        this.updateState(nextProps)
      } else {
        clearInterval(this.timer)
        this.launchTimer()
      }
    }
  }
  // function starting the timer
  launchTimer() {
    // Initial calculation for elapsed time
    this.tick()
    // Setup the timer to update every second the elapsed time
    this.timer = setInterval(this.tick, 3000)
  }
  // Update State function
  tick = () => {
    this.updateState(this.props)
  }
  render() {
    const { table, classes } = this.props
    let style = classes.normalStyle
    const transac = table.currentTransaction
    if (
      transac &&
      transac.pool.isPaused &&
      !transac.canceled &&
      !transac.transfertTo
    ) {
      style = classes.pauseStyle
    } else if (
      transac &&
      !transac.pool.isPaused &&
      !transac.canceled &&
      !transac.transfertTo
    ) {
      style = classes.runningStyle
    }
    let tableClass = 'table'
    switch (table.type) {
      case 'american':
        tableClass += ' american'
        break
      case 'pool':
        tableClass += ' pool'
        break
      case 'snooker':
        tableClass += ' snooker'
        break
      case 'carom':
        tableClass += ' carom'
        break
      case 'chinese':
        tableClass += ' chinese'
        break
      default:
        tableClass += ' american'
    }
    tableClass += table.isVertical ? ' vertical' : ' horizontal'
    const loading = !!(
      table.loading ||
      (table.currentTransaction &&
        (table.currentTransaction.transfertTo ||
          table.currentTransaction.canceled))
    )
    return (
      <Draggable
        bounds={{ top: 0, left: 0 }}
        disabled
        position={{ x: parseInt(table.posX, 10), y: parseInt(table.posY, 10) }}
        grid={[10, 10]}>
        <Paper className={classNames(style, tableClass)} elevation={3}>
          {getTableIcon(table.type)}
          {transac && !transac.canceled && !transac.transfertTo ? (
            <span className={classes.totalSpan}>{this.state.total + ' €'}</span>
          ) : null}
          <Button
            disabled={loading}
            className={classes.tableButton}
            size="large"
            onClick={this.handleClick}>
            {table.num}
          </Button>
          {loading && (
            <CircularProgress
              size={32}
              thickness={3}
              className={classes.buttonProgress}
            />
          )}
        </Paper>
      </Draggable>
    )
  }
}
const mapActionCreators = {
  showModal
}
PlanSingleComponent.propTypes = propTypes
export default connect(state => state, mapActionCreators)(
  withRouter(withStyles(styles)(PlanSingleComponent))
)



// WEBPACK FOOTER //
// ./src/routes/Home/components/PlanSingleComponent.js